import * as React from 'react';
import KPSelectableListItem from './KPSelectableListItem'
import { ISelectableList, ISelectableListItem } from '../../../../interfaces/KPSelectableList/KPSelectableListInterfaces';
import './KPSelectableList.css'

class KPSelectableList extends React.PureComponent<ISelectableList, any> {
    constructor(props) {
        super(props);

        this.state = {
            items: this.props.items ?? []
        };

        this.handleSelect = this.handleSelect.bind(this);
    }

    setList(items: ISelectableListItem[]) {
        this.setState({ items });
    }

    getList(): ISelectableListItem[] {
        return [...this.state.items ];
    }

    getSelection(): ISelectableListItem[] {
        return this.state.items.filter(x => x.selected);
    }

    handleSelect(id, selected) {
        let items = [...this.state.items];

        if (this.props.radioGroup && selected) {
            items.filter(x => x.id !== id).forEach(item => { item.selected = false; });
            items.filter(x => x.id === id).forEach(item => { item.selected = true; });  // Can only deselect by selecting another item from group.
        }
        else if (!this.props.radioGroup) {
            items.filter(x => x.id == id).forEach(item => { item.selected = selected; });
        }

        this.setState({ items });

        if (this.props.handleSelect) {
            this.props.handleSelect(id, selected);
        }
    }

    public render() {
        let items:any = <></>;
        if (this.state.items && this.state.items.length > 0) {
            items = this.state.items.map((item, index) => {
                return <KPSelectableListItem
                    key={index}
                    id={item.id}
                    label={item.label}
                    value={item.value}
                    selected={item.selected}
                    className={item.className + (this.props.radioGroup ? " radioGroup" : " checkboxGroup")}
                    required={item.required}
                    disabled={item.disabled}
                    handleSelect={this.handleSelect}
                    selectOnLeft={item.selectOnLeft}
                />
            });
        }

        return (
            <div className={"ssp-selectable-list" + (this.props.autosize ? " ssp-selectable-list-autosize" : "")}>
                {items}
            </div>
        );
    }
}

export default KPSelectableList